export const resetChannelState = (chId)=>{
  return dispatch=>{
    dispatch({ type: "RESET_CHANNEL_STATE" })
  }
}